/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformAdminVerifyUserAccount } from '../../models/platform-admin-verify-user-account';
import { PlatformApiResultOfUserAccountDto } from '../../models/platform-api-result-of-user-account-dto';

export interface PostUseraccountsActionAdminVerify$Params {
      body: PlatformAdminVerifyUserAccount
}

export function postUseraccountsActionAdminVerify(http: HttpClient, rootUrl: string, params: PostUseraccountsActionAdminVerify$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserAccountDto>> {
  const rb = new RequestBuilder(rootUrl, postUseraccountsActionAdminVerify.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfUserAccountDto>;
    })
  );
}

postUseraccountsActionAdminVerify.PATH = '/api/useraccounts/action/admin-verify';
